import React from 'react';
import './button.css';

interface ButtonProps {
    enabled?: boolean;
    onClick?: () => void;
    text?: string;
    children?: React.ReactNode;
}

export const Button: React.FC<ButtonProps> = ({ enabled = true, onClick = () => {}, text = '', children }) => {
    return (
        <button
            className={`button-agendamento ${enabled ? 'enabled' : ''}`}
            onClick={() => (enabled ? onClick() : undefined)}
        >
            {text}
        </button>
    );
};
